export default __webpack_public_path__ + "static/media/video.7d6d8c1a.png";